import { Component, Input, OnInit } from '@angular/core';
import { EBClaimStatusVm } from '../../../models/eb-claim-status-vm';

@Component({
  selector: 'app-eb-claim-status-details',
  templateUrl: './eb-claim-status-details.component.html',
  styleUrls: ['./eb-claim-status-details.component.scss']
})
export class EbClaimStatusDetailsComponent implements OnInit {

  claimStatusTitles = {
    completed : 'COMPLETED',
    pending : 'PENDING',
    decline : 'DECLINE',
    medicalReview : 'MEDICAL REVIEW',
    review : 'REVIEW',
    additionalDocRequired : 'ADDITIONAL DOCUMENT REQUIRED',
    approved : 'APPROVED & READY FOR PAYMENT',
    sentForPayment : 'SENT FOR PAYMENT'
  }

  constructor() { }

  ngOnInit() {}

  @Input() claimStatusList :EBClaimStatusVm[];

  getSummary(summary:string){
    if(!summary)
      return null;

    let items = summary.split(':');
    if(items.length > 1)
      return '<b>'+ items[0] +' : </b>' + items[1];
    else
      return summary;
  }
}
